export var BusinessKYCDocumentType;
(function (BusinessKYCDocumentType) {
    /**
     * Represents the representative type for the business
     *
     * Values:
     * Ultimate Beneficial Owner (UBO)
     *
     * Company Director
     *
     * Company Representative
     */
    BusinessKYCDocumentType["RepresentativeType"] = "REPRESENTATIVE_TYPE";
    /**
     * Represents the user's date of birth in ISO 8601 format (big-endian)
     * @example 2026-12-10
     */
    BusinessKYCDocumentType["DateOfBirth"] = "DATE_OF_BIRTH";
    // /**
    //  * Represents the user's identification type
    //  */
    // IDType = 'ID_TYPE',
    // /**
    //  * Represents the user's identification number
    //  */
    // IDNumber = 'ID_NUMBER',
    /**
     * Represents home/business address with street, city, and country
     */
    BusinessKYCDocumentType["Address"] = "ADDRESS";
    /**
     * Represents a bank statement document, typically used to
     * verify financial information or account ownership.
     */
    BusinessKYCDocumentType["BankStatement"] = "BANK_STATEMENT";
    /**
     * Represents a business certificate or registration document,
     * used to verify the legitimacy of a business entity.
     */
    BusinessKYCDocumentType["BusinessCertificate"] = "BUSINESS_CERTIFICATE";
    /**
     * Represents the country of residence or citizenship in ISO 3166 alpha-2 format,
     * typically verified through a government-issued document.
     */
    BusinessKYCDocumentType["Country"] = "COUNTRY";
    /**
     * Represents the front side of an identity document,
     * such as a national ID card or driver's license.
     */
    BusinessKYCDocumentType["IDFront"] = "ID_FRONT";
    /**
     * Represents the back side of an identity document,
     * often containing additional information or security features.
     */
    BusinessKYCDocumentType["IDBack"] = "ID_BACK";
    /**
     * Represents a selfie photo of the user, typically used
     * for facial recognition and identity verification.
     */
    BusinessKYCDocumentType["Phone"] = "PHONE";
    /**
     * Represents a selfie photo of the user, typically used
     * for facial recognition and identity verification.
     */
    BusinessKYCDocumentType["Selfie"] = "SELFIE";
    /**
     * Represents a document that serves as proof of address,
     * similar to Address but may include additional formats.
     */
    BusinessKYCDocumentType["ProofOfAddress"] = "PROOF_OF_ADDRESS";
    /**
     * Represents a document that serves as proof of income,
     */
    BusinessKYCDocumentType["ProofOfIncome"] = "PROOF_OF_INCOME";
    /**
     * Represents a Bank Verification Number (BVN), which is a
     * unique identifier used in the Nigerian banking system.
     */
    BusinessKYCDocumentType["BVN"] = "BVN";
    /**
     * Represents a driver's license, which serves as both
     * an identity document and proof of driving privileges.
     */
    BusinessKYCDocumentType["DriverLicense"] = "DRIVER_LICENSE";
    /**
     * Represents a passport document, used for international
     * identity verification and travel purposes.
     */
    BusinessKYCDocumentType["Passport"] = "PASSPORT";
    /**
     * Represents a national identity card or document,
     * issued by a government as official proof of identity.
     */
    BusinessKYCDocumentType["NationalID"] = "NATIONAL_ID";
    /**
     * Represents a payment method instrument such as a bank card or a credit card or a debit card
     */
    BusinessKYCDocumentType["PaymentMethod"] = "PAYMENT_METHOD";
    /**
     * Represents a permit document, typically used to
     * verify residence or citizenship in a specific country.
     */
    BusinessKYCDocumentType["ResidencePermit"] = "RESIDENCE_PERMIT";
    /**
     * Represents a vehicle registration document, typically used to
     * verify ownership or registration of a vehicle.
     */
    BusinessKYCDocumentType["VehicleRegistration"] = "VEHICLE_REGISTRATION";
    /**
     * Represents a voter ID.
     */
    BusinessKYCDocumentType["VoterId"] = "VOTER_ID";
    /**
     * Represents a document that is not categorized under any other type.
     */
    BusinessKYCDocumentType["Others"] = "OTHERS";
    /**
     * ==================  TYPES: END ====================
     */
})(BusinessKYCDocumentType || (BusinessKYCDocumentType = {}));
//# sourceMappingURL=BusinessKYCDocumentType.js.map